import { navigateTo } from '../../routing/Navigation';

export const viewCategorySlots = (categoryCode: string) => {
  navigateTo(`/my-account?category=${categoryCode}`);
};
